/**
 * Strips invalid characters from the text.
 */
export const stripInvalidCharacters = (text: string) => text.replace('\u2028', '');
